import React, { useState } from "react";
import CourseCard from "../CourseCard/CourseCard.js";
import ExamCards from "../../students/ExamCards/ExamCards.js";
import FeeCards from "../FeeManagement/FeeCards.js";
import StatsCounter from "../../../subscreens/StatsCounter/StatsCounter.js";
import HeroSection from "../../../screen/students/herosection/HeroSection.js";
import BlogCard from "../../../components/students/BlogCard/BlogCard.js";
import Eventgallery from "../../../subscreens/eventpage/Eventgallery.js";
import { useNavigate } from "react-router-dom";
import '../../../assests/css/students/Home.css';
import ContactForm from "../../../subscreens/contact/ContactForm.js";
import SpinnerLoading from "../../../components/SpinnerLoading/SpinnerLoading.js";
import "../../../assests/css/students/Career.css"
import EventGallery from "../../../subscreens/eventpage/Eventgallery.js";



const Home = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // Fires spinner for `delay` ms, then navigates
  const handleNavigate = (path, delay = 800) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      navigate(path);
    }, delay);
  };

  return (
    <>
      {/* ── Global spinner overlay ── */}
      {isLoading && <SpinnerLoading fullScreen />}

      <HeroSection />
      <CourseCard />

      {/* Features Section */}
      <h6 className="cb-section-title">Career Consultation</h6>
      <section className="career-consultation__features">
        <div className="career-consultation__features-grid">
          <div className="career-consultation__feature">
            <div className="career-consultation__feature-icon">🤖</div>
            <h3 className="career-consultation__feature-title">AI Career & Education Guidance</h3>
            <p className="career-consultation__feature-text">
An AI-based system that provides personalized education and career guidance according to students’ interests, skills, qualifications, and current market trends.

            </p>
          </div>

          <div className="career-consultation__feature">
            <div className="career-consultation__feature-icon">📊</div>
            <h3 className="career-consultation__feature-title">Market Insights</h3>
            <p className="career-consultation__feature-text">
             Provides students with insights into current education trends and career opportunities to help them choose suitable educational and career paths.

            </p>
          </div>

          <div className="career-consultation__feature">
            <div className="career-consultation__feature-icon">🎯</div>
            <h3 className="career-consultation__feature-title">Personalized Roadmap</h3>
            <p className="career-consultation__feature-text">
           Gives students a simple and personalized education and career plan based on their interests, skills, studies, and career goals, with clear steps to reach their desired career.

            </p>
          </div>
        </div>
      </section>

    

      <StatsCounter />


    

      <ExamCards />
      <FeeCards />

      <EventGallery />
      <div className="see-more-wrapper">
        <button
          className="see-more-btn"
          disabled={isLoading}
          onClick={() => handleNavigate("/eventpage")}
        >
          See More
        </button>
      </div>

      <ContactForm />
    </>
  );
};

export default Home;